module.exports = __webpack_public_path__ + "img/end_periode_quiz.4497e938.png";